import { render, staticRenderFns } from "./NoshiCard.vue?vue&type=template&id=cd1b5d34&lang=pug&"
import script from "./NoshiCard.vue?vue&type=script&lang=ts&"
export * from "./NoshiCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports